<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true"
  [config]="{ignoreBackdropClick: true, keyboard: false}" (onShown)="onShown()">
  <div class="modal-dialog modal-lg">
    <mat-progress-bar *ngIf="isBusy" mode="indeterminate"></mat-progress-bar>
    <div class="card modal-content" *ngIf="form">
      <form (ngSubmit)="save()" [formGroup]="form">
        <div class="header">
          <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h2>Disponibilidade de Agenda</h2>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" *ngIf="errors.length > 0">
            <h3>Oops! Algo deu errado:</h3>
            <ul>
              <li *ngFor="let error of errors">{{error}}</li>
            </ul>
          </div>
          <div class="row">            
            <div class="col-md-4" *ngIf="newItem">
              <mat-form-field>
                <mat-label>Dias da Semana</mat-label>                
                <mat-select formControlName="diasSemana" multiple required #focus>
                  <mat-option *ngFor="let dayOfWeek of typesService.dayOfWeekType" [value]="dayOfWeek.value">
                    {{dayOfWeek.text}}</mat-option>
                </mat-select>
                <mat-error>Selecione os Dias da Semana.</mat-error>
              </mat-form-field>
            </div>            
            <div class="col-md-4" *ngIf="!newItem">
              <mat-form-field>
                <mat-label>Dia da Semana</mat-label>                
                <mat-select formControlName="diaSemana" required #focus>
                  <mat-option *ngFor="let dayOfWeek of typesService.dayOfWeekType" [value]="dayOfWeek.value">
                    {{dayOfWeek.text}}</mat-option>
                </mat-select>
                <mat-error>Selecione os Dias da Semana.</mat-error>
              </mat-form-field>
            </div>            
            <div class="col-md-2">
              <mat-form-field>
                <mat-label>Horário Inicial</mat-label>
                <input matInput formControlName="horarioInicial" type="time" />
                <mat-error>Informe um Horário Inicial válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field>
                <mat-label>Horário Final</mat-label>
                <input matInput formControlName="horarioFinal" type="time" />
                <mat-error>Informe um Horário Final válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field>
                <mat-label>Duração</mat-label>
                <input matInput formControlName="duracao" type="time" />
                <mat-error>Informe um Duração válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field>
                <mat-label>Classificação</mat-label>                
                <mat-select formControlName="classificacaoId">
                  <mat-option *ngFor="let classificacao of classificacoes" [value]="classificacao.value">
                    {{classificacao.text}}</mat-option>
                </mat-select>
                <mat-error>Selecione uma Classificação de Agendamento.</mat-error>
              </mat-form-field>              
            </div>            
          </div>
        </div>
      </form>
      <div class="footer">
        <mat-slide-toggle [(ngModel)]="multiCreate" color="primary" *ngIf="newItem" style="margin-right: 10px;">
          Continuar Incluindo
        </mat-slide-toggle>
        <button mat-flat-button [disabled]="!form.valid || isBusy" type="submit" (click)="save()" color="primary"
          class="button-row">
          <span> Salvar</span>
        </button>
        <button mat-stroked-button type="button" [routerLink]="" (click)="close()" class="button-row">
          <span> Cancelar</span>
        </button>
      </div>
    </div>
  </div>
</div>